export const ECHO_WEB_STATUS = {
  approved: 1,
  not_submitted: null,
  pending: 0,
  rejected: 40,
} as const;
